<template>
  <div>
      <resource-photo-album
          style="margin-top: 75px;"
          v-if="userData"
          :resource="selectedResource"
          :settings="settings"
          :user-data="userData"
          :is-management-mode="isManagementMode"
          :my-app-settings_is-display-activity="displayActivity"
          :my-app-settings_is-display-settings="displaySettings"
      />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RecordViews from "@/mixins/RecordViews";
import ResourcePhotoAlbum from "@/components/blockResources/resourcePhotoAlbum";
export default {
  name: "CornerPublishing",
  mixins: [RecordViews],
  components: {
    ResourcePhotoAlbum
  },
  beforeMount() {
    this.myAppName = this.$route.params.myAppName;
    this.heartbeatId = this.$route.params.heartbeatId;
    this.resourcePath = this.$route.params.resource;
    this.resourceItemPath = this.$route.params.resourceItem;

    if (this.resourcePath) {
      console.log(
        `Title: ${this.myAppName} | Resource: ${this.resourcePath} | ResourceItem: ${this.resourceItemPath} `
      );
    }
  },
  mounted() {
    this.getMyAppDisplayData();
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    publishing() {
      return this.corner ? this.corner.doc : null;
    }
  },
  methods: {
    handleNoData() {
      this.$router.push("/");
    },
    getMyAppDisplayData() {
      this.$store
        .dispatch("listings/getPublishedMyAppDisplayByNameAndHeartBeat",
            {
              myAppName: this.myAppName,
              heartbeat: this.heartbeatId
            }
        )
        .then(res => {
          if (Object.keys(res).length === 0) {
            this.handleNoData();
            //@Todo Record that data was not reached
          } else {
            this.heartBeatDisplay = res;
            this.userData = res && res.heartbeatData ? res.heartbeatData : null;
            this.recordView(this.corner.id);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    recordView(publishingId) {
      this.$store.dispatch("listings/recordFeedback", {
        userId: this.user ? this.user.uid : null,
        pathId: "publishings",
        entityId: publishingId,
        feedbackType: "views",
        sessionId: this.checkSession("sessions")
      });
    }
  },
  metaInfo() {
    return {
      title: "JourneyBinder Blog",
      meta: [
        // Twitter Card
        { name: "twitter:title", content: this.blogTitle },
        { name: "twitter:card", content: "Our Blog Page" },
        { name: "twitter:description", content: this.description },
        { name: "twitter:image", content: this.logo },
        { property: "og:title", content: this.blogTitle },
        { property: "og:site_name", content: "JourneyBinder" },
        { property: "og:type", content: "website" },
        { property: "og:image", content: this.logo },
        { property: "og:description", content: this.description }
      ]
    };
  },
  data() {
    return {
      corner: null,
      myAppName: null,
      heartbeatId: null,
      resourcePath: null,
      resourceItemPath: null,
      heartBeatDisplay: null,
      selectedResource: null,
      settings: null,
      isManagementMode: null,
      userData: null,
      displayActivity: false,
      displaySettings: false
    };
  },
};
</script>
